// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ArticleEndPlateInfoVO')
export class ArticleEndPlateInfoVO {
  @JsonProperty('id', 'Number')
  public id: number = undefined;
  @JsonProperty('articleNo', 'String')
  public articleNo: String = undefined;
  @JsonProperty('otherArticleNo', 'String')
  public otherArticleNo: String = undefined;
  @JsonProperty('deleted', 'Number')
  public deleted: number = undefined;
  @JsonProperty('rotated', 'Boolean')
  public rotated: boolean = undefined;
}
